// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".category-editor.rc-dropdown__submenu .category-editor__saving{position:absolute;top:-25px;right:0;font-style:italic;font-weight:500}.category-editor.rc-dropdown__submenu.analytics__category-editor{top:auto;left:312px}\n", ""]);
// Exports
module.exports = exports;
